import { createSlice } from '@reduxjs/toolkit';

export const projectSliceName = 'project';

export const projectInitialState = {
  checklist: [],
  checklistOptions: [],
  payments: [],
  projectTypeActive: '',
  projectTypeActiveHash: '',
  projectsTypes: [],
  projectsDetails: {}
};

export const projectSlice = createSlice({
  name: projectSliceName,
  initialState: projectInitialState,
  reducers: {
    setChecklist: (state, action) => {
      state.checklist = action.payload;
      state.checklistOptions = [];
    },
    setChecklistOptions: (state, actions) => {
      const checklistItemId = actions.payload.id;
      const checklistItemOptions = actions.payload.options;
      const checklistItemIndex = state.checklist.findIndex(checklistItem => checklistItem.id === checklistItemId);

      state.checklist[checklistItemIndex] = {
        ...state.checklist[checklistItemIndex],
        options: checklistItemOptions
      };
    },
    setChecklistOptionsChecked: (state) => {
      state.checklistOptions = state.checklist['reduce']((accumulator, currentValue) => {
        const optionList = currentValue.options.filter(option => option.isChecked);
        const optionType = currentValue.optionsType;
        const optionTypeIgnore = 'TEXT';

        accumulator = [
          ...accumulator,
          ...(optionType === optionTypeIgnore ? [] : optionList)
        ];

        return accumulator;
      }, [])
    },
    setChecklistOptionsDisabled: (state) => {
      const disabledIdsOptions = state.checklistOptions.filter(option => option.disableIds && option.disableIds.length);
      const disabledIds = disabledIdsOptions['reduce']((accumulator, currentValue) => {
        accumulator = [
          ...accumulator,
          ...currentValue['disableIds']
        ]
        return accumulator;
      }, []);

      state.checklist = state.checklist.map((checklistItem) => {
        if (checklistItem.options && checklistItem.options.length) {
          return {
            ...checklistItem,
            options: checklistItem.options.map((option) => ({
              ...option,
              isDisabled: disabledIds.includes(option.id)
            }))
          }
        }
        return checklistItem;
      });
    },
    setPayments: (state, action) => {
      state.payments = action.payload;
    },
    setProjectType: (state, action) => {
      state.projectTypeActive = action.payload;
    },
    setProjectTypeHash: (state, action) => {
      state.projectTypeActiveHash = action.payload;
    },
    setProjectsTypes: (state, action) => {
      state.projectsTypes = action.payload;
    },
    setProjectsDetails: (state, action) => {
      state.projectsDetails = action.payload;
    }
  }
});

export const {
  setChecklist,
  setChecklistOptions,
  setChecklistOptionsChecked,
  setChecklistOptionsDisabled,
  setPayments,
  setProjectType,
  setProjectTypeHash,
  setProjectsTypes,
  setProjectsDetails,
} = projectSlice.actions;

export default projectSlice.reducer;
